<div *ngIf="showTag"
    class="settings-cog pointer-events-none fixed bottom-5 right-0 z-[9999] flex h-10 items-center justify-center rounded-l-lg rounded-r-none bg-opacity-60 px-3 shadow-lg print:hidden"
    [ngClass]="tagClasses">
    <span class="text-xs font-semibold text-white">
        {{ tagLabel }}
    </span>
</div>